<script setup lang="ts">
  import {
    Button,
    ButtonType,
    ButtonVariant,
    type ButtonTypeType,
  } from '@tundr/ds-components';
  import { sidePanelActionsContainerClass } from './SidePanelActions.css';

  type SidePanelActionsProps = {
    confirmLabel?: string;
    confirmTestId?: string;
    disableConfirm?: boolean;
    cancelLabel?: string;
    cancelTestId?: string;
    disableCancel?: boolean;
    loadingConfirm?: boolean;
    loadingCancel?: boolean;
    confirmDisabledReason?: string;
    confirmType?: ButtonTypeType;
  };

  defineProps<SidePanelActionsProps>();

  const emits = defineEmits<{
    confirm: [];
    cancel: [];
  }>();
</script>

<template>
  <div :class="sidePanelActionsContainerClass">
    <Button
      :test-id="cancelTestId || 'cancel-side-panel-button'"
      :variant="ButtonVariant.Inline"
      :disabled="disableCancel"
      v-if="cancelLabel"
      @click="emits('cancel')"
      :loading="loadingCancel"
      >{{ cancelLabel }}
    </Button>
    <Button
      :test-id="confirmTestId || 'confirm-side-panel-button'"
      :variant="ButtonVariant.Primary"
      :type="confirmType || ButtonType.Button"
      v-if="confirmLabel"
      :disabled="disableConfirm"
      :loading="loadingConfirm"
      @click="emits('confirm')"
      :disabled-reason="confirmDisabledReason"
      >{{ confirmLabel }}
    </Button>
  </div>
</template>
